export default __webpack_public_path__ + "static/gopher-direct-access-7a3f2fc7ccbe6b7025f3ac93907af6fb.svg";